import { render, staticRenderFns } from "./HeadMenu.vue?vue&type=template&id=f6968466&scoped=true"
import script from "./HeadMenu.vue?vue&type=script&lang=js"
export * from "./HeadMenu.vue?vue&type=script&lang=js"
import style0 from "./HeadMenu.vue?vue&type=style&index=0&id=f6968466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6968466",
  null
  
)

export default component.exports